import routeMatch from './route-match';
var getCurrentRoute = function (urlPath, routers) {
    return routers.find(function (_a) {
        var routePath = _a.path;
        return routeMatch(urlPath, routePath);
    });
};
export default getCurrentRoute;
//# sourceMappingURL=get-current-route.js.map